module.exports = __webpack_public_path__ + "static/img/11.463aacd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/10/sp/11.png
// module id = C8y8
// module chunks = 0